export default __webpack_public_path__ + "static/media/Successfully.9ddc0cc3.svg";